import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../_common/_service/authservice.service';
@Component({
  selector: 'app-KoraBankresponse',
  templateUrl: './KoraBankresponse.component.html',
  styleUrls: ['./KoraBankresponse.component.scss']

})
export class KoraBankresponseComponent implements OnInit {

  userresponsemsg: any;
  userresponsestatus: any;
  beneficiarynumber: any;
  entryDate: any;
  eziPayReferenceId: any;
  remark: any;
  totalAmount: any;
  transactionStatus: any;

  txnRef: any;
  merchantCode: any;

  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {


    this.getParamValueQueryString();

  }

  getParamValueQueryString() {
    debugger
    const url = window.location.href;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      this.txnRef = httpParams.get('reference');
    }
    //{ "status": "successful", "tx_ref": "EZB-2022-1072069", "transaction_id": "632764155", "flag": null }

    if (this.txnRef != null || this.txnRef != undefined ) {

      this. KoraBankSubmitBankresponseapi(null, this.txnRef, null);//CAll API       

    }

  }

   KoraBankSubmitBankresponseapi(status: any, tx_ref: any, transaction_id: any) {
    
     this.authService.KoraBankSubmitBankresponseapi(status, tx_ref, transaction_id).subscribe(response => {
       
      this.userresponsestatus = response.apiStatus;
      this.merchantCode = response.apiStatusCode;
      if (response.apiStatus == true) {
        if (response.apiStatusCode == "M") {
          window.location.href = response.apiData;
        }
        else {

          this.beneficiarynumber = response.apiData.beneficiarynumber;
          this.entryDate = response.apiData.entryDate;
          this.eziPayReferenceId = response.apiData.eziPayReferenceId;
          this.remark = response.apiData.remark;
          this.totalAmount = response.apiData.totalAmount;
          this.transactionStatus = response.apiData.transactionStatus;

        }
      }
      else {

        this.userresponsemsg = response.apiMessage;
      }
    });
  }

}
